import React from 'react'
import { DatePicker, Radio } from 'antd'
import { ComponentExt } from 'util/reactExt'
import moment from 'moment'
import { Chart, Geom, Axis, Tooltip } from 'bizcharts'
import styles from './index.scss'

const currentDate = moment().format('YYYY-MM')
const { MonthPicker } = DatePicker

const studyMinsFormatter = min =>
  min ? Math.round((Number(min) / 60) * 100) / 100 : 0

const percentFormatter = percent =>
  percent ? Math.round(Number(percent) * 100 * 100) / 100 : 0

const filedsTextMap = {
  study: '总学习时长',
  articles: '视频学习数量',
  percent: '视频完成度(%)',
}

const tabs = Object.keys(filedsTextMap).map((tab, i) => ({
  key: tab,
  name: filedsTextMap[tab],
}))

interface ICompareWithToptenChartProps {
  entityid?: string | number
}

class ICompareWithToptenChart extends ComponentExt<
  ICompareWithToptenChartProps
> {
  state = {
    data: [],
    currentMode: 'study',
    pkMoment: moment(),
    pkDate: currentDate,
  }

  componentDidMount() {
    this.fetchCompareData(currentDate)
  }

  async fetchCompareData(date) {
    const data = await this.api.user.getTeamCompareWithToptenData(
      date,
      this.props.entityid,
    )
    data.forEach(x => {
      x[filedsTextMap.study] = studyMinsFormatter(x.study)
      x[filedsTextMap.articles] = Number(x.articles)
      x[filedsTextMap.percent] = percentFormatter(x.finish_percent)
    })
    this.setState({
      data,
    })
  }

  handlePkVolChange = e => {
    const currentMode = e.target.value
    this.setState({
      currentMode,
    })
  }

  handleSetDate = (m, date) => {
    const pkDate = date
    this.setState({
      pkMoment: m,
      pkDate,
    })

    if (date) {
      this.fetchCompareData(date)
    }
  }

  render() {
    const currentVol = filedsTextMap[this.state.currentMode]

    return (
      <div>
        <h4 className={styles.header}>
          <div className={styles.filterBar}>
            <Radio.Group
              onChange={this.handlePkVolChange}
              value={this.state.currentMode}
              style={{ marginRight: 24 }}
            >
              {tabs.map(t => (
                <Radio.Button key={t.key} value={t.key}>
                  {t.name}
                </Radio.Button>
              ))}
            </Radio.Group>
            <MonthPicker
              placeholder={'请选择日期'}
              value={this.state.pkMoment}
              defaultValue={moment()}
              disabledDate={current =>
                (current && current > moment().endOf('day')) ||
                current < moment('2018-01-01')
              }
              onChange={(m, date) => this.handleSetDate(m, date)}
            />
          </div>
          <p>注：当前排名，以“总学习时长”为主</p>
        </h4>

        <Chart
          padding={[20, 205, 70, 80]}
          height={400}
          data={this.state.data}
          forceFit
        >
          <Axis name="entity_name" />
          <Axis name={currentVol} />
          <Tooltip
            crosshairs={{
              type: 'y',
            }}
          />
          <Geom type="interval" position={`entity_name*${currentVol}`} />
        </Chart>
      </div>
    )
  }
}

export default ICompareWithToptenChart
